import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from './api/AuthProvider';
import 'bootstrap/dist/css/bootstrap.min.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './static/css/Index.css';
import './static/css/App.css';
import './static/css/Layout/Navbar.css';
import './static/css/Home/Hero.css';
import './static/css/Home/Features.css';
import './static/css/Home/FeatureGrid.css';
import './static/css/Home/InsightsSection.css';
import './static/css/Home/FAQSection.css';
import './static/css/Home/TestimonialSection.css';
import './static/css/Layout/Footer.css';
import './static/css/Layout/Hamburger.css';
import './static/css/Pages/Solutions/SolutionsHero.css';
import './static/css/Pages/Solutions/SolutionBlock.css';
import './static/css/Pages/Solutions/ResultsSection.css';
import './static/css/Pages/Pricing/PricingHero.css';
import './static/css/Pages/Pricing/PricingIncluded.css';
import './static/css/Pages/Pricing/WhyNectr.css';
import './static/css/Pages/OurWork/OurWorkHero.css'
import './static/css/Pages/GetStarted.css'
import './static/css/Pages/Account.css'
import './static/css/Pages/OurWork/Sites/BarCaligo.css'

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <AuthProvider>
        <App />
    </AuthProvider>
);